// src/config/api.js
const API_CONFIG = {
//   BASE_URL: 'http://localhost:3001', // Change this URL to update everywhere
    BASE_URL: 'https://paspuss.us', // Change this URL to update everywhere
  // You can add other API-related configurations here if needed
  TIMEOUT: 10000,
  // API_VERSION: 'v1',
};

export default API_CONFIG;